/**
 * =========================================================================================
 *  Digital Signature - Employee Flow (Open from mail Link or Direct in HRMS)
 * =========================================================================================
 *
 **/
import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useSelector} from "react-redux";
import UModal from 'ubs-framework/v2/UModal/NewUModal'
import UIcon from 'ubs-framework/v2/UIcon';
import useUAlert from "ubs-framework/v2/UAlert";
import {useForceUpdate} from "ubs-framework/v2/hooks/useForceUpdate";
import Validator from "simple-react-validator";
import useSocket from "../../../app-ats/common/hooks/useSocket";
import {COLOR, PAGINATION} from "ubs-framework/v2/common/constant";
import {api, sendData} from "../../../store/actions";
import { dateFormatter, getLocal, showToastSuccess, getThumbor } from "ubs-framework/v2/common/function";
import UButton from "ubs-framework/v2/UButton";
import {useHistory, useParams, useRouteMatch} from "react-router-dom";
import UNameJobInfo from "ubs-framework/v2/UNameJobInfo";
import * as Icon from "ubs-icons";
import Skeleton from "ubs-framework/v2/skeleton";
import {PREBOARDING_STEPS, STATUS_CONST} from "../../constant";
import NoDataFound from "ubs-framework/v2/no-data-found";

const AddSignatureModal = React.lazy(()=> import("../../../app-ats/settings/preboarding-settings/signature-settings/add-signature-modal"))

const publicPath = '/sign/document';

const EmployeeSignature = (props) => {
    let matchPath = useRouteMatch(publicPath)?.path;
    const matchCandidate = useRouteMatch("/:orgId/boarding-document/:id")?.isExact;
    const {url} = useRouteMatch();
    const {id} = useParams();
    const history = useHistory();
    const alert = useUAlert();
    const forceUpdate = useForceUpdate();
    const validator = useRef(new Validator({
        element: (message, className) => <div className={'u_error'}>{message}</div>,
        autoForceUpdate: {forceUpdate}
    }));

    const _ORG_ID = useSelector(e => e.common.orgId);
    const _USER = useSelector(e => e.common?.userInfo);
    const _PID = useSelector(e => e.common.preBoardingId);
    const _PST = useSelector(e => e.common.preBoardingStatus);
    const _SOCKET_ID = useSelector(e => e.common.socketId);
    const _S3_BASE_URL = useSelector(e => e.common.S3_BASE_URL);

    const  [pageLoading,setPageLoading] = useState(false);
    const  [authError,setAuthError] = useState(false);
    const [signatureList, setSignatureList] = useState([]);
    const [sameData, setSameData] = useState({});
    const [othKeyName, setOthKeyName] = useState("");
    const [authKeyName, setAuthKeyName] = useState("");
    const [employeeKeyName, setEmployeeKeyName] = useState("");
    const [allValues,setAllValues] = useState({
        docName: "",
        personName:"",
        signatureDate:"",
        candidateName: "",
        isCandidateSign: false, // this will true if the signature of candidate is done
    });
    const [selectedSignatureId,setSelectedSignatureId] = useState(null);
    const [openModal,setOpenModal] = useState(false);
    const [createSignatureFlag, setCreateSignatureFlag] = useState(false);
    const [editSignatureFlag, setEditSignatureFlag] = useState(false);
    const [htmlPage,setHtmlPage] = useState({
        header:"",
        bodyContent:"",
        footer:"",
    });
    const [btnFlags, setBtnFlags] = useState({
        start: true,
        next: false,
        save: false,
        thankYou: false,
        disable: false,
        saveBtnLoading: false,
        signEntireDisabled: false,
    });
    const [idName,setIdName] = useState(0);
    let [totalSignature ,setTotalSignature] = useState(0);
    let [signatureLeft ,setSignatureLeft] = useState(0);
    let [userId ,setUserId] = useState("");
    let [documentConfirmed ,setDocumentConfirmed] = useState(false);
    let [docAssigneeName, setDocAssigneeName] = useState("");
    let [showNoData, setShowNoData] = useState(false);
    let [docWithoutSign, setDocWithoutSign] = useState(false);  // if document have no signature employee signature placeholder Make it true else false,
    const documentData = getLocal('document-data');
    useEffect(() => {
        if(matchPath !== publicPath){
            on();
            // sendData('hrms|setting|digital|signature|list', {currentPage: PAGINATION.CURRENT_PAGE , limit: PAGINATION.LIMIT100 , user: _USER_ID});
            return () => off()
        }else if(id){
            publicApi?.getDocument();
            publicApi?.getSignatureListing();
        }
    }, [id]);

    useEffect(() => {
        if(props?.file?._id ){
            resetAllStates();
            sendData('hrms|setting|digital|signature|list', {currentPage: PAGINATION.CURRENT_PAGE || 1 , limit: PAGINATION.LIMIT100 || 100 , user: userId});
            sendData('ats|pre|boarding|candidate|document|fetch',{_id: props?.file?._id });
        };

    }, [props?.file?._id ]);

    useEffect(() => {
        if(matchCandidate && +props?.file?.templateType === 1 && !docWithoutSign){
            /**
             * disable accept offer button till signature is pending
             * docWithoutSign -->  document must have employee signature placeholder
             * */
            if(allValues?.isCandidateSign){
                props?.setAllData( _ => ({..._, disableAccept: false}));
            }else{
                props?.setAllData( _ => ({..._, disableAccept: true}));
            }
        };
    }, [props?.file?._id, allValues?.isCandidateSign, docWithoutSign] )

    const resetAllStates = () =>{
        setSignatureList([]);
        setSameData({})
        setOthKeyName("");
        setAuthKeyName("");
        setEmployeeKeyName("");
        setAllValues({docName: "", personName:"", signatureDate:"",candidateName: "",})
        setSelectedSignatureId(null);
        setOpenModal(false);
        setCreateSignatureFlag(false);
        setEditSignatureFlag(false);
        setHtmlPage({header:"", bodyContent:"", footer:"",});
        setBtnFlags({start: true, next: false, save: false, thankYou: false, disable: false, saveBtnLoading: false, signEntireDisabled: false,})
        setIdName(0);
        setTotalSignature(0);
        setSignatureLeft(0);
        setUserId("");
        setDocumentConfirmed(false);
        setDocAssigneeName("");
    };

    const replaceFunctions = {
        replacePlaceholder: (data, name = "Sign Here") => {
            let userName = (name?.length > 14) ? name?.slice(0, 12) + "..." : name;
            let htmlString = data;
            htmlString = htmlString?.replace(/<img/gi, "<img class='' style='display:inline-block;vertical-align: middle;' ");
            htmlString = htmlString?.replace(/(\{\{auth\.signature[0-9]\}\})|(\{\{emp\.signature\}\})|(\{\{oth\.signature[0-9]\}\})/gi,
                `<span class='u_relative u_emp-signature-signContainer'>
                        <svg width="150" height="40" viewBox="0 0 150 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.5" y="0.5" width="149" height="39" rx="3.5" fill="white" stroke="#007AFF" stroke-dasharray="3 3"/>
                            <path d="M12.3164 28.1012C12.1733 27.9593 12.0931 27.7679 12.0931 27.5682C12.0931 27.3687 12.1733 27.1772 12.3164 27.0353C12.6208 26.6942 13.0728 26.1975 13.9427 26.1975C14.8127 26.1975 15.2798 26.7109 15.5843 27.0502C15.849 27.3469 15.9133 27.3914 16.0759 27.3914C16.2386 27.3914 16.3028 27.3469 16.5676 27.0502C16.8702 26.7111 17.324 26.1975 18.2091 26.1975C19.0941 26.1975 19.548 26.7109 19.8506 27.0502C20.1154 27.3469 20.1796 27.3914 20.3423 27.3914C20.5049 27.3914 20.5692 27.3469 20.8339 27.0502V27.0501C21.0137 26.8488 21.2893 26.7568 21.5571 26.8087C21.8247 26.8605 22.044 27.0486 22.1319 27.3018C22.2199 27.5551 22.1635 27.835 21.9837 28.0363C21.6811 28.3755 21.2273 28.8891 20.3422 28.8891C19.4571 28.8891 19.0032 28.3756 18.7006 28.0363C18.4359 27.7397 18.3716 27.6952 18.209 27.6952C18.0463 27.6952 17.9821 27.7397 17.7173 28.0363C17.4147 28.3755 16.9609 28.8891 16.0778 28.8891C15.1946 28.8891 14.7351 28.3756 14.4269 28.0363C14.1621 27.7397 14.0979 27.6952 13.9352 27.6952C13.7725 27.6952 13.7083 27.7397 13.4435 28.0363L13.4114 28.0697L13.3887 28.0937L13.3885 28.0939C13.2477 28.2346 13.0552 28.3146 12.854 28.3159C12.6529 28.3173 12.4593 28.2401 12.3163 28.1012L12.3164 28.1012ZM14.4496 24.0379L10.4914 26.1086C10.3273 26.1948 10.1375 26.221 9.95557 26.183C9.77367 26.1449 9.61143 26.0448 9.49759 25.9005C9.38375 25.7563 9.32584 25.5771 9.33401 25.3949L9.52318 21.0016C9.53057 20.8699 9.57225 20.7423 9.64414 20.6308L15.537 11.5476C15.6482 11.3744 15.8251 11.2517 16.0286 11.2065C17.046 10.981 18.113 11.16 18.9958 11.7046C19.8785 12.2492 20.5049 13.1146 20.7375 14.1112C20.7837 14.3108 20.7469 14.5202 20.6354 14.6933L14.7426 23.7766C14.6693 23.8868 14.5683 23.9768 14.4495 24.0379L14.4496 24.0379ZM13.5172 22.7719C13.3364 22.2957 13.0005 21.891 12.5618 21.6202C12.1229 21.3495 11.6054 21.2278 11.0891 21.2742L11.0229 22.9907C11.4012 23.0679 11.7376 23.2783 11.9684 23.582L13.5172 22.7719Z" fill="#007AFF"/>
                        </svg>
                        <span class='u_absolute u_emp-signature-SignatureImage u_cp u_text-bold' style='top:7px; left:75px; width:100%; transform: translate(-30%, -120%);overflow:hidden; color: #007AFF; font-size: 14px; text-align: left'> ${userName}</span>
                        <span class='u_absolute u_emp-signature-tooltip'>click to select signature</span>
                    </span> `);

            htmlString = htmlString?.replace(/(\{\{auth\.signature[0-9]\}\})|(\{\{emp\.signature\}\})|(\{\{oth\.signature[0-9]\}\})/gi,
                `<span class='u_relative u_emp-signature-signContainer'>
                    <img class='u_cp u_ib ' style='width:150px; height:45px;' src='/images/employee-signature.svg' />
                    <span class='u_absolute u_emp-signature-SignatureImage u_cp'  style='top:50%; left:50%; width:85px; height:20px; background-color: #fff; transform: translate(-30%, -120%); overflow:hidden; color: #007AFF; font-size: 14px; text-align: left' > ${userName} </span>
                    <span class='u_absolute u_emp-signature-tooltip'>click to select signature</span>
                </span> `);
            return htmlString;
        },
        replaceImages :(data, url) =>  {
            let htmlString = data;
            htmlString = htmlString?.replace(/<img/gi, "<img class='' style='display:inline-block;vertical-align: middle;' ");

            htmlString = htmlString?.replace(/(\{\{auth\.signature[0-9]\}\})|(\{\{emp\.signature\}\})|(\{\{oth\.signature[0-9]\}\})/gi,
                '<span class="u_relative u_emp-signature-signContainer">' +
                '<img class="u_cp u_signature-is-selected u_emp-signature-notConfirmedSign u_emp-signature-SignatureImage" ' +
                'style="display:inline-block; width:150px; height:45px;" src="'+ url+'"  />' +
                "<span class=\'u_absolute u_emp-signature-tooltip\'  >click to confirm</span>" +
                "</span>");
            return htmlString;
        }
    };

    const findFunctions = {
        findAuthors: (documentSettings, authorized)=> {
            let author = new Set()
            let bodyContent = documentSettings?.bodyContent?.match(/(auth\.signature[0-9])/gmi);
            let header = documentSettings?.header?.contents?.match(/(auth\.signature[0-9])/gmi);
            let footer = documentSettings?.footer?.contents?.match(/(auth\.signature[0-9])/gmi);
            if (bodyContent) {author.add(...bodyContent)};
            if (header) {author.add(...header)};
            if (footer) {author.add(...footer)};
            for (const item of author) {
                setAuthKeyName(item?.split(".")[1]);
            };
        },
        findOther:(documentSettings)=>  {
            let other = new Set();
            let bodyContent = documentSettings?.bodyContent?.match(/(oth\.signature[0-9])/gmi);
            let header = documentSettings?.header?.contents?.match(/(oth\.signature[0-9])/gmi);
            let footer = documentSettings?.footer?.contents?.match(/(oth\.signature[0-9])/gmi);
            if (bodyContent) {other.add(...bodyContent)};
            if (header) {other.add(...header)};
            if (footer) {other.add(...footer)};
            for (const item of other) {
                setOthKeyName(item?.split(".")[1]);
            };
        },
        findEmployee:(documentSettings)=>  {
            let employee = new Set();
            let bodyContent = documentSettings?.bodyContent?.match(/(emp\.signature)/gmi);
            let header = documentSettings?.header?.contents?.match(/(emp\.signature)/gmi);
            let footer = documentSettings?.footer?.contents?.match(/(emp\.signature)/gmi);
            if (bodyContent) {employee.add(...bodyContent)};
            if (header) {employee.add(...header)};
            if (footer) {employee.add(...footer)};
            if(employee?.size === 0){
                /** if document have no signature employee signature placeholder Make it true else false,*/
                setDocWithoutSign(true)
                if(props?.setAllData) props?.setAllData(_=> ({..._, disableAccept: false}));
                setDocWithoutSign(true);
            }
            for (const item of employee) {
                setEmployeeKeyName(item?.split(".")[1]);
            };
        },

    };

    const {on, off, refresh} = useSocket(async(res) => {
        if (!res.error && _SOCKET_ID === res?.data?.socketId) {
            switch (res.event) {
                case "ats|pre|boarding|candidate|document|fetch": {
                    setSameData(prev => ({...prev, ...res?.data?.result}));
                    findFunctions?.findAuthors(res?.data?.result?.documentSettings);
                    findFunctions?.findOther(res?.data?.result?.documentSettings);
                    findFunctions?.findEmployee(res?.data?.result?.documentSettings);
                    let bodyContent = replaceFunctions?.replacePlaceholder(res?.data?.result?.documentSettings?.bodyContent, _USER?.name);
                    let header =  replaceFunctions?.replacePlaceholder(res?.data?.result?.documentSettings?.header?.contents, _USER?.name);
                    let footer =  replaceFunctions?.replacePlaceholder( res?.data?.result?.documentSettings?.footer?.contents, _USER?.name);

                    setHtmlPage((prev)=>({...prev, header: {...res?.data?.result?.documentSettings?.header, contents: header},
                        bodyContent:bodyContent ,
                        footer: {...res?.data?.result?.documentSettings?.footer, contents: footer}}));
                    setUserId((prev )=> (res?.data?.result?.user?._id));
                    setAllValues({
                        docName: res?.data?.result?.documentName,
                        personName: `${res?.data?.result?.createdBy?.firstName} ${res?.data?.result?.createdBy?.lastName}`,
                        signatureDate:res?.data?.result?.createdAt,
                        candidateName: `${res?.data?.result?.user?.firstName || ""} ${res?.data?.result?.user?.lastName || ""}`,
                        ...(matchCandidate && {isCandidateSign: res?.data?.result?.documentObject?.employee?.signature?.isSignature || false}) // true when candidate have sign on document
                    });
                    break;
                }
                case "ats|documents|update":{
                    setBtnFlags(prev => ({...prev,saveBtnLoading: false, disable: true }))
                    // setBtnFlags((prev)=>({...prev,thankYou:true }));
                    if (props?.isAuthor) {
                        history.push(`/${_ORG_ID}/preboarding/document-signature`);
                    } else if(matchCandidate) {
                        if(props?.setAllData){
                            props?.setAllData( prev => ({...prev,disableAccept: false, isSignature: true }));
                        }
                        setBtnFlags(_ => ({..._,}))
                    } else {
                        props?.setShowThankYou(true)
                    }
                    break;
                }
                case "hrms|setting|digital|signature|list": {
                    let List = []
                    res?.data?.result?.map((item)=>{
                        let obj = {isDefault:"" ,_id :"",url: "",backendURL:"", valueType :"" ,nameValue : "" , initialValue :"", fontFamily :{}, sId :"" }
                        obj.isDefault= item?.isDefault;
                        obj._id = item?._id;
                        obj.url = `${getThumbor('375x165')}${_S3_BASE_URL}${item?.fileKey?.url}`;
                        obj.backendURL =  `${_S3_BASE_URL}${item?.fileKey?.url}`;
                        obj.valueType = item?.valueType;
                        List?.unshift(obj);
                    })
                    setSignatureList(List)
                    break;
                }
                default:
                    return true;
            }
        };
    });

    const handle = {
        replaceHTML :({selectedSignatureId = "", imageURL = ""})=>{
            let  selectedSign = {};
            if(matchPath !== publicPath){
                let [selected] = signatureList.filter((sign)=> {return sign?._id === selectedSignatureId});
                selectedSign = selected;
            };
            let bodyContent =  replaceFunctions?.replaceImages(sameData?.documentSettings?.bodyContent, selectedSign?.backendURL || imageURL);
            let footer =  replaceFunctions?.replaceImages(sameData?.documentSettings?.footer?.contents, selectedSign?.backendURL || imageURL);
            let header =  replaceFunctions?.replaceImages(sameData?.documentSettings?.header?.contents, selectedSign?.backendURL || imageURL);
            setSameData( prev =>  ({
                ...prev,
                documentObject:{
                    ...prev?.documentObject,
                    authorized:{
                        ...prev?.documentObject?.authorized,
                        ...(authKeyName && {[authKeyName]: {isSignature: true, user: _USER?.value, sId: selectedSignatureId,}})
                    },
                    employee:{
                        ...prev?.documentObject?.employee,
                        ...(employeeKeyName && {[employeeKeyName]: {isSignature: true, user: _USER?.value, sId: selectedSignatureId,}})
                    },
                    other:{
                        ...prev?.documentObject?.other,
                        ...( othKeyName &&{[othKeyName]: {isSignature: true, user: documentData?.user, sId: selectedSignatureId,email:documentData?.email}})
                    }
                },
                documentSettings:{
                    ...prev?.tempDocumentSettings,
                },
            }));
            setSelectedSignatureId(selectedSignatureId);
            setHtmlPage({header: {contents:header} , footer:{contents:footer}, bodyContent: bodyContent,});
            setBtnFlags(prev => ({ ...prev,start: false, next: true , save: false }));
            setOpenModal(false);
        },
        signNow : useCallback((selectedSignatureId)=>{handle?.replaceHTML({selectedSignatureId})}),
        signNowPublic: async (selectedSignatureId)=>{
            const config = {headers: {'Authorization': getLocal('signature'),'Content-Type':"application/json"}};
            try {
                const response  = await api.post("/public/signature/list", {"limit" : 100, "currentPage" : 1 , user: documentData?.user},config);
                if(!response.error){
                    let [selectedSign] = response?.data?.data?.result?.filter((sign)=> {return (sign?._id === selectedSignatureId)});
                    handle?.replaceHTML({
                        selectedSignatureId:selectedSignatureId,
                        imageURL: `${getThumbor('375x165')}${documentData?.S3_BASEURL}${selectedSign?.fileKey?.url}`});
                }
            }catch(error){
                setAuthError(true);
            }
        },
        signEntire: useCallback(() => {
            showToastSuccess("All Signature Confirm Successfully.");
            let images  = document.getElementsByClassName('u_emp-signature-SignatureImage');
            for (let i = 0; i < images?.length ; ++i) {
                images[i]?.classList?.add('u_emp-signature-confirmedSign');
                images[i]?.classList?.remove('u_emp-signature-notConfirmedSign','u_cp');
                let tooltip = images[i]?.nextSibling;
                tooltip.innerHTML = 'confirmed';
            };
            setBtnFlags(prev => ({...prev,
                start: false,
                next: false,
                save: true,
                thankYou: false,
                disable: false,
                saveBtnLoading: false,
                signEntireDisabled:true,
            }))
            setSignatureLeft(0);
        }),
        open:()=>{
            validator.current.hideMessages();
            setOpenModal(true);
        },
        nextSignature:()=>{
            if(idName <= totalSignature -1 ){
                setIdName((prev) => prev+1);
            }else{
                setIdName(0);
            }
        },
        allSignatureConfirmed: ()=>{
            let images  = document.getElementsByClassName('u_emp-signature-SignatureImage');
            let countConfirm = 0;
            let countNotConfirm = images?.length -1;
            for (let i = 0; i < images?.length ; i++) {
                if(images[i]?.getAttribute('class')?.includes('u_emp-signature-confirmedSign')){
                    ++countConfirm ; --countNotConfirm;
                }
            }
            if(countConfirm !== images?.length){
                 setSignatureLeft(countNotConfirm);
                 if(countNotConfirm === 0 ){
                     showToastSuccess("All Signature Confirm Successfully.");
                    setBtnFlags(prev => ({...prev,start: false, next: false, save: true, thankYou: false, disable: false, saveBtnLoading: false,}))
                 }
            }
            return (countConfirm > images?.length -1) ? true : false;
        },
        saveDocument:()=>{
            alert.show({
                title: 'Almost Done',
                description: `Are you sure want to submit signed document ?`,
                icon: <span className="u_icon u_red-bgicon u_m-auto"><Icon.Warning size={30} fill={COLOR.u_red}/></span>,
                submit: 'Submit',
                onSubmit: async () => {
                    if(matchPath !== publicPath ){
                        await sendData("ats|documents|update", {
                            ...sameData,
                            _id: sameData?._id,
                            user: sameData?.user?.user,
                            email: sameData?.email,
                            isVerified: btnFlags?.save,
                            isSignature: true,
                            templateType: 1,
                            preBoardingId:  props?.isAuthor  ?  props?.file?._id : _PID , // when author person sign on document , preboarding employee - _PID
                        })
                        await setBtnFlags(prev =>({...prev, saveBtnLoading:true}));
                    }else {
                        const config = {headers: {'Authorization': getLocal('signature'),'Content-Type':"application/json"}};
                        try {
                            const response  = await api.post("/public/signature/preboarding/document/update", { ...sameData, _id :sameData?._id , user:sameData?.user?.user , email:sameData?.email, isVerified : btnFlags?.save},config);
                            if(!response.error){
                                setBtnFlags(prev => ({...prev,
                                    start: false,
                                    next: false,
                                    save: true,
                                    disable: true,
                                    saveBtnLoading: false,
                                    signEntireDisabled: true,
                                    thankYou:true }))
                                setSignatureLeft(0)
                                setPageLoading(false);
                            }
                        }catch(error){
                            setAuthError(true);
                        }
                    }

                }
            });
        },
        redirectAfterSubmit : async () =>{
            if(matchPath !== publicPath ){
               if( url?.includes('my-profile/documents/official')) {
                   // history?.push(`/${_ORG_ID}/my-profile/documents/official/`);
               }else{
                   // history?.push(`/${_ORG_ID}/inbox/signature-request`);
                   // sendData('hrms|master|inbox|documentRequest|list',{});
               }
            }else{
                if(!documentConfirmed){
                    // window.location.reload(true);
                }
            }
        }
    }

    const publicApi ={
        getSignatureListing:async ()=>{
            const config = {headers: {'Authorization': getLocal('signature'),'Content-Type':"application/json"}};
            try {
                const response  = await api.post("/public/signature/list", {"limit" : 100, "currentPage" : 1 , user: documentData?.user},config);
                if(!response.error){
                    publicApi?.signatureListResponse(response.data);
                    return response.data;
                }
            }catch(error){
                setAuthError(true);
                return error;
            }
        },
        getDocument :async () => {
            const config = {headers: {'Authorization': getLocal('signature'),'Content-Type':"application/json"}};
            try {
                const response  = await api.post("/public/signature/preboarding/document/fetch", {"_id":id},config);
                if(!response.error){
                    publicApi?.docFetchResponse(response?.data);
                    setPageLoading(false);
                }
            }catch(error){
                setAuthError(true);
            }
        },
        docFetchResponse: async (res)=>{
            //to check document is confirmed ot not.
            // Signing continues after Move to Hire, same as the authorized person's list; a future-reference offer stays hidden
            setShowNoData(!(res?.data?.result?.steps === PREBOARDING_STEPS.OFFER_ACCEPTANCE || (res?.data?.result?.steps === PREBOARDING_STEPS.HIRED && res?.data?.result?.status !== STATUS_CONST.FUTURE_REFERENCE)));
            const otherObj = res?.data?.result?.documentObject?.other || {}
            const [signatureConfirmed] = Object?.keys(otherObj)?.filter(keyName => otherObj[keyName]?.user === documentData?.user);

            // Header + document for both cases: an already-signed signer reopening the link sees the signed copy (server renders the signature) instead of a blank page
            setDocAssigneeName(`${res?.data?.result?.createdBy?.firstName} ${res?.data?.result?.createdBy?.lastName}`)
            let bodyContent = await replaceFunctions?.replacePlaceholder(res?.data?.result?.documentSettings?.bodyContent, "Sign here");
            let header = await replaceFunctions?.replacePlaceholder(res?.data?.result?.documentSettings?.header?.contents, "Sign here");
            let footer = await replaceFunctions?.replacePlaceholder(res?.data?.result?.documentSettings?.footer?.contents, "Sign here");
            await setHtmlPage((prev) => ({
                ...prev, header: {...res?.data?.result?.documentSettings?.header, contents: header},
                bodyContent: bodyContent,
                footer: {...res?.data?.result?.documentSettings?.footer, contents: footer}
            }));
            setAllValues({
                docName: res?.data?.result?.documentName,
                personName: `${res?.data?.result?.createdBy?.firstName} ${res?.data?.result?.createdBy?.lastName}`,
                signatureDate: res?.data?.result?.createdAt,
            });

            if(otherObj[signatureConfirmed]?.isSignature){
                setDocumentConfirmed(true)
                setBtnFlags(prev => ({...prev,
                    start: false,
                    next: false,
                    save: true,
                    disable: true,
                    saveBtnLoading: false,
                    signEntireDisabled: true,
                    thankYou:true }))
                setSignatureLeft(0)
                setPageLoading(false);
            }else {
                setSameData(prev => ({...prev, ...res?.data?.result}));
                findFunctions?.findOther(res?.data?.result?.documentSettings);
                setUserId((prev) => (res?.data?.result?.user?._id));
            }
        },
        signatureListResponse :(res)=>{
            let List = []
            res?.data?.result?.map((item)=>{
                let obj = {isDefault:"" ,_id :"",url: "",backendURL:"", valueType :"" ,nameValue : "" , initialValue :"", fontFamily :{}, sId :"" }
                obj.isDefault= item?.isDefault;
                obj._id = item?._id;
                obj.url = `${getThumbor('375x165')}${documentData?.S3_BASEURL}${item?.fileKey?.url}`;
                obj.backendURL =  `${documentData?.S3_BASEURL}${item?.fileKey?.url}`;
                obj.valueType = item?.valueType;
                List?.unshift(obj);
            });
            setSignatureList(List);
        },
    }


    useEffect(() => {
        let images  = document.getElementsByClassName('u_emp-signature-SignatureImage');
        for (let i = 0; i < images?.length ; ++i) {
            images[i]?.addEventListener('click', function addClassAndEvent(){
                //after selecting signature this class add in image tag "u_signature-is-selected"
                if(!this?.getAttribute('class')?.includes('u_signature-is-selected')){
                    handle?.open();
                }else {
                    if(!this.getAttribute('class')?.includes('u_emp-signature-confirmedSign')){
                        if(!handle?.allSignatureConfirmed() &&  !this.getAttribute('class')?.includes('u_emp-signature-confirmedSign')){
                            if(!this.getAttribute('class')?.includes('u_emp-signature-confirmedSign')){
                                this?.classList?.add('u_emp-signature-confirmedSign');
                                this?.classList?.remove('u_emp-signature-notConfirmedSign','u_cp');
                                let tooltip = this?.nextSibling;
                                tooltip.innerHTML = 'confirmed';
                            }
                        }
                    }
                }
            },)
            images[i]?.setAttribute('id', `u_${i}`);
        };
        totalSignature = images?.length;
        setTotalSignature((prev)=> images.length)
        setSignatureLeft((prev)=> images.length)
        return()=>{
            let images  = document.getElementsByClassName('u_emp-signature-SignatureImage')
            for (let i = 0; i < images?.length ; i++) {
                images[i]?.removeEventListener('click', function addClassAndEvent(){}, false)
                images[i]?.removeAttribute('id');
            }
        }
    }, [htmlPage]);

    useEffect(() => {
        /** this Effect is  select css for header footer image and apply same css using Javascript so affecting css will override*/
        let header = document?.querySelector(".u_emp-signature-header > p > img");
        let footer = document?.querySelector(".u_emp-signature-footer > p > img");
        if (header && footer && header?.width && footer?.width) {
            header.style.width = `${header?.width}px`;
            footer.style.width = `${footer?.width}px`;
        }
    }, [htmlPage?.footer?.contents, htmlPage?.header?.contents])


    return (
        <React.Fragment>
            <div className="u_emp-signature u_h-full u_w-full">
                { pageLoading && !showNoData ?
                <DocumentSkeleton />
                    :showNoData ?
                    <React.Fragment >
                        <NoDataFound/>
                    </React.Fragment>
                    :<React.Fragment >
                        <div className="u_emp-signature-heading  u_flex u_content-between u_align-center u_w-full u_flex-wrap">
                            <div className="u_flex u_align-center u_p-15 ">
                                {
                                    <React.Fragment>
                                        <UNameJobInfo
                                            avatar={publicPath === matchPath ? <Icon.Superworks size={40} fill={COLOR.u_orange}/>  : <UIcon color="#007AFF" thumb={34} showBorder={false} icon={<Icon.Info size={14} fill={COLOR.u_blue}/>}/>}
                                            name={publicPath === matchPath ? "": `Candidate Name : ${allValues?.candidateName || "-"}`}
                                            job={publicPath === matchPath ? "": "Requested By : " +  allValues?.personName}
                                            className={ publicPath === matchPath ? "u_br-light" : "u_pr-15 u_br-light"} />
                                            <div className="u_ml-10 u_br-light" >
                                                <div className="u_emp-signature-heading-left u_mb-7 u_mr-10">Signature Left : <span>  {signatureLeft}</span></div>
                                                <p className="u_emp-signature-heading-email u_flex u_align-center u_mr-10">
                                                    {publicPath === matchPath && <Icon.Mail className="" fill={COLOR.u_icon_bg} size={12}/>}
                                                    { publicPath === matchPath   ? <span className={"u_ml-5"}> {documentData?.email || "-"} </span> : <span className={"u_font-12"}>{dateFormatter({date: allValues?.signatureDate})}</span>   }
                                                </p>
                                            </div>
                                            { publicPath === matchPath && <div className="u_ml-10" ><div className="u_emp-signature-heading-document-name"> {allValues?.docName || "-"}</div></div>}
                                    </React.Fragment>
                                }
                            </div>

                            <div className="u_flex u_align-center u_flex-wrap">
                                {publicPath === matchPath &&
                                    <div className="u_ml-15">
                                        <div className="u_emp-signature-heading-requested u_mb-5">Requested By</div>
                                        <div className="u_emp-signature-heading-requested-user">  {docAssigneeName || "-"} </div>
                                    </div>
                                }
                                { (matchCandidate ? (!allValues?.isCandidateSign && Boolean(!docWithoutSign)) : (true) ) ?
                                    <div className="u_emp-signature-heading-right u_w-120 u_flex u_align-center u_p-15">
                                        {<UButton
                                            disabled={btnFlags?.saveBtnLoading || btnFlags?.disable || btnFlags?.signEntireDisabled}
                                            loading={btnFlags?.saveBtnLoading}
                                            variant="white" type={"Sign Entirely"}
                                            cn="u_emp-signature-submitBtn u_mr-10 "
                                            onClick={(btnFlags.start && !btnFlags?.save) ? handle?.open : (selectedSignatureId) ? handle?.signEntire : null}/>
                                        }

                                        {!btnFlags?.next &&
                                        <UButton disabled={btnFlags?.saveBtnLoading || btnFlags?.disable}
                                                 loading={btnFlags?.saveBtnLoading}
                                                 variant="blue"
                                                 type={(btnFlags.start && !btnFlags?.save) ? "Start Signing" : (btnFlags.save) ? "Save" : null}
                                                 cn="u_emp-signature-submitBtn u_mr-10"
                                                 onClick={(btnFlags.start && !btnFlags?.save) ? handle?.open : (btnFlags.save) ? handle?.saveDocument : null}/>
                                        }
                                        {btnFlags?.next &&
                                        <a href={`#u_${idName}`}
                                           className={`u_emp-signature-submitBtn u_text-center u_ib u_btn u_btn__smallBtn u_btn__largeBtn u_btn__blue u_mr-10 u_w-100`}
                                           onClick={handle.nextSignature}
                                           style={{
                                               color: "#fff",
                                               textDecoration: "none",
                                               width: "100%",
                                               height: "100%",
                                               fontSize: "12px"
                                           }}>Next Signature</a>
                                        }
                                    </div> : ""
                                }
                            </div>
                        </div>

                        { (url?.includes('preboarding/document-signature') || url?.includes("boarding-document")) &&
                            <div className={`u_emp-signature-body  ${  matchCandidate ? "u_emp-signature-official-candidate" : "u_emp-signature-official-authorized"} u_mt-15 u_w-full u_h-full u_p-10`} style={{overflowY: "scroll"}}>
                                <div className="u_emp-signature-header" dangerouslySetInnerHTML={{__html: htmlPage?.header?.contents}}/>
                                <div className="u_post-content" dangerouslySetInnerHTML={{__html: htmlPage?.bodyContent}}/>
                                <div className="u_emp-signature-footer" dangerouslySetInnerHTML={{__html: htmlPage?.footer?.contents}}/>
                        </div>}

                        {url?.includes("sign/document") &&
                        <div className="u_w-full u_h-full u_emp-signature-body u_emp-signature-publicUrl u_mt-15 u_p-10" style={{overflowY: "scroll"}}>
                                <div className="u_emp-signature-header"  dangerouslySetInnerHTML={{__html: htmlPage?.header?.contents}}/>
                                <div className="u_post-content" dangerouslySetInnerHTML={{__html: htmlPage?.bodyContent}}/>
                                <div className="u_emp-signature-footer"  dangerouslySetInnerHTML={{__html: htmlPage?.footer?.contents}}/>
                        </div>}
                    </React.Fragment>}
            </div>

            {openModal && <AddSignatureModal
                openSignatureModal={openModal}
                setOpensigantureModal={setOpenModal}
                signNow={matchPath !== publicPath ? handle?.signNow : handle?.signNowPublic}
                createSignatureFlag={createSignatureFlag}
                editSignatureFlag={editSignatureFlag}
                setEditSignatureFlag={setEditSignatureFlag}
                setCreateSignatureFlag={setCreateSignatureFlag}
            />}

            {btnFlags?.thankYou && <UModal
                open={true}
                maxWidth={640}
                onClose={() => {
                    setBtnFlags((prev) => ({...prev, thankYou: false}))
                    handle?.redirectAfterSubmit();
                }}
                className="u_apply-popup"
                isHeaderShow={false}
            >
                <div className="u_p-25 u_text-center">
                    <div className="u_m-auto">
                        <img src="/images/thank-you.svg" alt="Thank you" className="u_m-auto"/>
                    </div>
                    <h2 className="u_mb-10">Thank You!</h2>
                    <p className="u_small-font">Your document has been successfully submitted. We have received your signed document and will get back to you soon</p>
                </div>
            </UModal>}
        </React.Fragment>
    );
};


const DocumentSkeleton = () => {
    return (
        <React.Fragment>
            <div className="u_h-full u_w-full">
                <div className="u_other-signature-heading ">
                    <Skeleton width="100%" height="80px" className=""/>
                </div>
                <div className="u_other-signature-body u_mt-15 ">
                    <Skeleton width="70%" height="100%" className="u_mx-auto u_other-signature-body-skeleton"/>
                </div>
            </div>
        </React.Fragment>
    );
};

export default EmployeeSignature;
